/**
 * Resources whose show route puts another record in `:id`: a
 * configuration's page is under its game
 * (`/platform/games/:id/configurations/:configurationId`), so `:id` is the
 * game's.
 */
const NESTED_SHOW_RESOURCES: ReadonlySet<string> = new Set([
  'gameConfigurations',
])

/** The actions of the nested routes: a configuration's page. */
const NESTED_ACTIONS: ReadonlySet<string> = new Set(['show'])

/**
 * The tab title (`DocumentTitleHandler`'s handler): Refine's own, except
 * on the nested show pages, where its `#<id>` would name the
 * game. They get it without the id (`Show Configurations | Refine`).
 */
export function documentTitle({
  resource,
  action,
  autoGeneratedTitle,
}: {
  resource?: { name: string }
  action?: string
  autoGeneratedTitle: string
}) {
  return action !== undefined &&
    NESTED_ACTIONS.has(action) &&
    resource !== undefined &&
    NESTED_SHOW_RESOURCES.has(resource.name)
    ? autoGeneratedTitle.replace(/^#\S+ /, '')
    : autoGeneratedTitle
}
